import * as React from 'react';
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CharConstants } from '../../../containers/WorkkardDetail/constants';
import NotePanelComponent from "../../../components/NotePanelComponent";
import { setPanelVisibility, getAllNoteTemplates, getSelectedNoteTemplateData, discardSelectedNoteTemplate, publishDraftNote, saveDraftNote, changeNoteModuleType, changeNoteType, changeNoteCreationActivityTemplate, publishNote } from "../../../containers/WorkkardDetail/actions/action";
import { addClass } from '../../../common/util';
import { dispatchCustomEvent } from '../../../containers/WorkkardDetail/utils';

const NotePanelContainer = (props) => {
    const dispatch = useDispatch();
    const {workkardDetail, activityDetail, panelVisibility, createNote, activityListing} = useSelector(state => state.workkardDetail);
    const {tzData} = useSelector(state => state.sessionContextOidc);


    // const getCurrentActivity = activityListing?.activities.find((val) => val.activityId == activityListing.currentActivity);
    // const ActivityData = {
    //     ActivityId: getCurrentActivity?.activityId,
    //     ActivityName: getCurrentActivity?.activityName,
    //     Progress: 0,
    //     WorkkardId: getCurrentActivity?.workkardId,
    //     // WorkkardNumber: "MS_0000_CLAIM", //todo
    //     currentResolution: getCurrentActivity?.resolution,
    //     // psnl: false,
    //     // pub: true,
    //     // pvt: true
    // }

    // const enrichedNoteData = React.useMemo(() => {
    //     const actData = {
    //         actid: activityListing?.activities.map((val) => val.activityId) ?? [],
    //         activities:{
    //             Activities:activityListing?.activities
    //         },
    //         name:activityListing?.activities.map((val) => val.activityName) ?? []
    //     };
    //     return {
    //         actData,
    //         tzData
    //     }
    // }, [activityListing]);

    const onSuccess = () => {
        if (props.referrer && props.referrer == "views") {
            props.onClose();
            const isIE = false || !!document.documentMode;
            dispatchCustomEvent(isIE, 'saveNoteInViewSuccesfully');
        }
    };

    const noteTemplateClick = (notetemplateId, moduleId, moduleType) => {
        dispatch(getSelectedNoteTemplateData({notetemplateId, moduleId, moduleType}));
    };

    const onChangeNoteType = (paramObj) => {
        dispatch(changeNoteType(paramObj));
    };

    const onActivityChange = (payload) => {
        dispatch(getAllNoteTemplates(payload, {referrer: props.hasOwnProperty('referrer') && props.referrer == "views" ? "views" : "" }));
    }


    const onPublishNoteHandler = (paramObj) => {
        const payload = {
            callback: () => onSuccess()
        };
        let data = Object.assign({}, paramObj, payload);
        dispatch(publishNote(data));
    };


    const onChangeModuleType = (paramObj) => {
        dispatch(changeNoteModuleType(paramObj));
    };

    // const onSaveAsDraft = (paramObj) => {
    //     const payload = {
    //         callback: () => onSuccess()
    //     };
    //     let data = Object.assign({}, paramObj, payload);
    //     dispatch(saveDraftNote(data));
    // };
    // const ondiscardNoteTemplateClick = (draftNoteId) => {
    //     dispatch(discardSelectedNoteTemplate(draftNoteId));
    //     props.referrer && props.referrer == "views" ? props.onClose() : null;
    // };
    // const onNoteTemplateActivityChange = (paramObj) => {
    //     dispatch(changeNoteCreationActivityTemplate(paramObj));
    // };


    useEffect(() => {
        //shrink the note panel if notification is open
        let body = document.querySelector("body");
        if (panelVisibility.isNotificationPanelOpen && !panelVisibility.isRightVisible) {
            addClass(body, 'openNotification');
        }
        let templateId = 0;
        if (panelVisibility.templateType === CharConstants.Workkard) {
            templateId = props.referrer && props.referrer == "views" ? props.moduleId : workkardDetail.Id;
        } else {
            templateId = props.referrer && props.referrer == "views" ? props.moduleId : activityDetail.activityId;
        }
        if (!panelVisibility.isNoteCreationVisible) {
            dispatch(getAllNoteTemplates({ tzdata:tzData, nttype: panelVisibility.templateType, templateId: templateId, referrer: props.hasOwnProperty('referrer') && props.referrer == "views" ? "views" : "" }));
        }
    }, []);


    const isFirstModuleIdRender = useRef(true);
    useEffect(() => {        
        if (isFirstModuleIdRender.current) {
            isFirstModuleIdRender.current = false;
            return;
        }
        if (props.referrer && props.referrer == "views") {
            const templateId = props.moduleId;
            if (panelVisibility.isNoteCreationVisible) {
                const noteTemplateid = 0;
                const paramObj = {
                    nttype: panelVisibility.templateType,
                    templateId: templateId,
                    noteTemplateid: panelVisibility.templateType === CharConstants.Activity ? createNote.createdDraftNote.DraftNote.NoteTemplateId : noteTemplateid,
                    // draftNoteId: panelVisibility.templateType === CharConstants.Workkard ? createNote?.selectedNoteDraftandTemplateData?.DraftNote?.Id : createNote.createdDraftNote.DraftNote.Id
                };
                dispatch(changeNoteModuleType(paramObj));
            } else if (!panelVisibility.isNoteCreationVisible && panelVisibility.templateType === CharConstants.Workkard) {
                dispatch(getAllNoteTemplates({ tzdata:tzData, nttype: panelVisibility.templateType, templateId: templateId, referrer: props.hasOwnProperty('referrer') && props.referrer == "views" ? "views" : "" }));
            }
        }
    }, [props.moduleId]);


    const isFirstTemplateTypeRender = React.useRef(true);
    useEffect(() => {
        console.log();
        
        if (isFirstTemplateTypeRender.current) {
            isFirstTemplateTypeRender.current = false;
            return;
        }
        if (!props.hasOwnProperty('referrer')) {
            const templateId = panelVisibility.templateType === CharConstants.Workkard ? workkardDetail.Id : activityDetail.activityId;
            if (panelVisibility.isNoteCreationVisible) {
                var noteTemplateid = 0;
                const paramObj = {
                    nttype: panelVisibility.templateType,
                    templateId: templateId,
                    noteTemplateid: panelVisibility.templateType === CharConstants.Activity ? createNote.createdDraftNote.DraftNote.NoteTemplateId : noteTemplateid,
                    // draftNoteId: panelVisibility.templateType === CharConstants.Workkard ? createNote.selectedNoteDraftandTemplateData.DraftNote.Id : createNote.createdDraftNote.DraftNote.Id
                };
                // dispatch(changeNoteModuleType(paramObj));
            }
        }
    }, [panelVisibility.templateType]);

    const notePanelProps = {
        setPanelVisibility: (panelVisibilityData) => dispatch(setPanelVisibility(panelVisibilityData)),
        noteTemplateClick,
        // ondiscardNoteTemplateClick,
        onPublishNoteHandler,
        // onSaveAsDraft,
        onChangeModuleType,
        onChangeNoteType,
        // onNoteTemplateActivityChange,
        onActivityChange,
        workkardDetail,
        activityDetail,
        panelVisibility,
        createNote,
    };

    return (
        <NotePanelComponent {...notePanelProps} {...props} />
    );
};

export default NotePanelContainer;